export const LOGIN = "login";
export const VERIFY_EMAIL = "verifyEmail";
export const VERIFY_OTP = "verifyOTP";